import Image, { type ImageProps } from 'next/image'

import { toMediaCdnUrl } from '@/utils/imageUrl'

/** Drop-in `next/image` for stored media URLs: serves S3 media through the CDN. */
const MediaImage = ({ src, alt, ...props }: ImageProps) => (
  <Image
    {...props}
    src={typeof src === 'string' ? toMediaCdnUrl(src) : src}
    alt={alt}
  />
)

export default MediaImage
